<div class="card mb-5 gantt-card" [style.minHeight]="resolvedCardHeight">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title">
      <div class="title-block">
        <h4>{{ data?.title | capitalCase }}</h4>
        <p class="timeline-range" *ngIf="rangeLabel">
          {{ rangeLabel }}
          <span *ngIf="taskCount" class="timeline-divider">•</span>
          <span *ngIf="taskCount">{{ taskCount }} items</span>
        </p>
      </div>
      <span class="timeline-mode">{{ timelineLabel }}</span>
    </div>
  </div>

  <div class="card-body">
    <div class="gantt-legend" *ngIf="legendItems.length">
      <button
        type="button"
        class="gantt-legend-item"
        [class.inactive]="!isLegendActive(item.label)"
        *ngFor="let item of legendItems"
        (click)="onLegendClick(item.label)"
      >
        <span class="gantt-legend-swatch" [style.background]="item.color"></span>
        <span class="gantt-legend-label">{{ item.label }}</span>
      </button>
    </div>

    <div class="chart-shell" [class.hidden]="hasError" [style.minHeight]="resolvedHeight">
      <div #chartHost [id]="data?.widgetId" class="chart-host" [style.height]="resolvedHeight"></div>
    </div>
    <div class="chart-error" *ngIf="hasError">{{ errorMessage }}</div>
  </div>
</div>
